import { JSX, ReactNode } from "react";
import {NavigateFunction, Location, Link} from "react-router-dom";

function buildLinkEl(from: Location, to: string, children: ReactNode): JSX.Element {
    return (
        <Link
            to={to}
            state={{from: from}}
        >
            {children}
        </Link>
    )
}

export const EventerConsoleNavigation = {

    accounts: {
        path: "/accounts",
        navigate: (navigate: NavigateFunction, from?: Location, replace?: Boolean): void => {
            navigate(EventerConsoleNavigation.accounts.path, {
                state: {from: from},
                replace: replace === true,
            })
        },

        new: {
            path: "/accounts/new",
            navigate: (navigate: NavigateFunction, from: Location, replace?: Boolean): void => {
                navigate(EventerConsoleNavigation.accounts.new.path, {
                    state: {from: from},
                    replace: replace === true,
                })
            },
        },

        account: (accountId: string) => {
            return {
                segment: accountId,
                path: `${EventerConsoleNavigation.accounts.path}/${accountId}`,
                navigate: (navigate: NavigateFunction, from: Location, replace?: Boolean): void => {
                    navigate(`${EventerConsoleNavigation.accounts.path}/${accountId}`, {
                        state: {from: from},
                        replace: replace === true,
                    })
                },

                events: {
                    segment: "events",
                    path: `${EventerConsoleNavigation.accounts.path}/${accountId}/events`,
                },

                importers: {
                    segment: "importers",
                    path: `${EventerConsoleNavigation.accounts.path}/${accountId}/importers`,
                    linkEl: (from: Location, children: ReactNode): JSX.Element => {
                        return buildLinkEl(from, `${EventerConsoleNavigation.accounts.path}/${accountId}/importers`, children)
                    },
                },

                invitations: {
                    segment: "invitations",

                    invitation: (invitationId: string) => {
                        return {
                            path: `${EventerConsoleNavigation.accounts.path}/${accountId}/invitations/${invitationId}`,
                        }
                    },

                    invitationTemplate: () => EventerConsoleNavigation.accounts.accountTemplate().invitations.invitation(":invitationId"),
                },

                services: {
                    segment: "services",
                    path: `${EventerConsoleNavigation.accounts.path}/${accountId}/services`,

                    emails: {
                        segment: "emails",
                        path: `${EventerConsoleNavigation.accounts.path}/${accountId}/services/emails`,
                        navigate: (navigate: NavigateFunction, from: Location, replace?: Boolean): void => {
                            navigate(`${EventerConsoleNavigation.accounts.path}/${accountId}/services/emails`, {
                                state: {from: from},
                                replace: replace === true,
                            })
                        },
                    },
                },

                help: {
                    segment: "help",
                    path: `${EventerConsoleNavigation.accounts.path}/${accountId}/help`,

                    gcal: {
                        segment: "gcal",
                        path: `${EventerConsoleNavigation.accounts.path}/${accountId}/help/gcal`,
                    },
                },

                settings: {
                    segment: "settings",
                    path: `${EventerConsoleNavigation.accounts.path}/${accountId}/settings`,

                    users: {
                        segment: "users",
                        path: `${EventerConsoleNavigation.accounts.path}/${accountId}/settings/users`
                    },
                    pod: {
                        segment: "pod",
                        path: `${EventerConsoleNavigation.accounts.path}/${accountId}/settings/pod`
                    },
                },
            }
        },
        accountTemplate: () => EventerConsoleNavigation.accounts.account(":accountId"),
    }
}